import { SHIFTS_FIELD } from '../constants';

const SHIFT_STEP_NAME_PATTERN = /^(.+)-(\d+)$/;

/**
 * The shift steps repeat once per shift, but `AppOnboarding` keys its steps by name — so each
 * repetition carries its shift index: `ShiftStep-0`, `ShiftStep-1`, …
 */
export const buildShiftStepName = (step: string, shiftIndex: number): string => `${step}-${shiftIndex}`;

/**
 * Splits a step name back into its base name and shift index. Steps that don't belong to a
 * shift (`LocationNameStep`, `PostcodeStep`, …) come back with an undefined index.
 */
export const parseStepName = (name = ''): { step: string; shiftIndex?: number } => {
  const match = SHIFT_STEP_NAME_PATTERN.exec(name);

  if (!match) {
    return { step: name };
  }

  return { step: match[1], shiftIndex: Number(match[2]) };
};

/** Form field path of a single shift, e.g. `shifts.1`. */
export const buildShiftFieldName = (shiftIndex: number): string => `${SHIFTS_FIELD}.${shiftIndex}`;
